export enum Permission {
  CREATE_LOAN_REQUEST = 'CREATE_LOAN_REQUEST',
  VIEW_MY_LOAN_REQUESTS = 'VIEW_MY_LOAN_REQUESTS',
  VIEW_ADVISOR_LOAN_REQUESTS = 'VIEW_ADVISOR_LOAN_REQUESTS',
  CREATE_OFFER = 'CREATE_OFFER',
}
